import GraphsPage from './GraphsContext'
import graphsHooks from './hooks'
import Graphs from './Graphs'

export { graphsHooks, Graphs }
export default GraphsPage